import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const CertificatesListWrapper = () => {
  const { t } = useTranslation("certificates")

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("lists.tabs.all"),
        link: "all",
      },
      {
        label: t("lists.tabs.scope"),
        link: "scope",
      },
      {
        label: t("lists.tabs.transaction"),
        link: "transaction",
      },
    ],
    [t]
  )

  return <Page title={t("lists.title")} pages={pages} />
}
